import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'
import el from './locales/el.json'

const i18n = createI18n({
  legacy: false, // Composition API
  locale: navigator.language.split('-')[0] || 'es', 
  fallbackLocale: 'es',
  messages: {
    es,
    en,
    el
  }
})

export default i18n
